import React from 'react'
import { Flex, Text } from '@chakra-ui/core'
import { Clock, AlertTriangle } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'

export type BadgeType = 'overdue' | 'hours' | 'none'

interface StatusBadgeProps {
  type: BadgeType
  value?: number | string
  width?: string | number
  bottom?: string | number
}

export const StatusBadge = ({ type, value, width = '130px', bottom = '30px' }: StatusBadgeProps) => {
  const overdue = useLocaleText('overdue')
  const t_hours = useLocaleText('t_hours')

  if (type === 'none') return null

  const isOverdue = type === 'overdue'

  return (
    <Flex
      position="absolute"
      border="2px solid white"
      bottom={bottom}
      left="50%"
      transform="translateX(-50%)"
      alignItems="center"
      justifyContent="center"
      bg={isOverdue ? '#EF4444' : '#FCD34D'}
      borderRadius="20px"
      w={width}
      px="12px"
      py="6px"
      style={{ gap: 6 }}
      boxShadow="0 2px 8px rgba(0,0,0,0.15)"
      minW="fit-content"
      whiteSpace="nowrap"
    >
      {isOverdue ? (
        <AlertTriangle size={14} color="white" strokeWidth={2.5} />
      ) : (
        <Clock size={14} color="#78350F" strokeWidth={2.5} />
      )}
      <Text fontSize="12px" fontWeight="bold" color={isOverdue ? 'white' : '#78350F'}>
        {isOverdue ? overdue : `${value} ${t_hours}`}
      </Text>
    </Flex>
  )
}
